import React from "react";
import SquarePreview from "../squarePreview/squarePreview";
import Thumb from "../appThumb/appThumb";
import { getRouteUrl } from "../../routers";
import { ROUTE_APPLICATION_VIEW } from "../../routers/content/application";

const ApplicationListItem = (props) => {
  const { uuid, title, nid, descriptionValue, image } = props.application;

  // Use actual image if available, otherwise use Thumb component
  const applicationIcon =
    image && image.url ? (
      <img
        src={image.url}
        alt={image?.alt || title || "Application"}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
    ) : (
      <Thumb number={nid} />
    );

  return (
    <SquarePreview
      primaryButton={getRouteUrl(
        ROUTE_APPLICATION_VIEW,
        {
          applicationId: uuid,
        },
        { organization: props.organizationUuid }
      )}
      title={title}
      description={descriptionValue}
      icon={applicationIcon}
      animated
      primaryButtonTitle="VIEW MORE"
    />
  );
};

export default ApplicationListItem;
